import { __awaiter } from "tslib";
import { OauthServiceType, useSocialAuthQuery } from '@websky/graphql';
import { telegramPath } from '../../SocialAuthCallback/utils';
import { useConfig } from '../../context';
import { getBackRedirectUrl, getBasePathUrl, setSocialAuthRedirectUrl } from './utils';
export const useRedirectToService = () => {
    const { global: { telegramLoginBotId, socialAuthCallbackUrl } } = useConfig();
    const socialAuth = useSocialAuthQuery({ skip: true });
    const getTelegramOAuthUrl = () => {
        const basePath = getBasePathUrl(socialAuthCallbackUrl);
        const returnTo = encodeURIComponent(`${basePath}${telegramPath}`);
        const origin = encodeURIComponent(socialAuthCallbackUrl);
        return `https://oauth.telegram.org/auth?bot_id=${telegramLoginBotId}&origin=${origin}&embed=1&request_access=write&return_to=${returnTo}`;
    };
    const redirectToService = ({ service, callback, onError }) => __awaiter(void 0, void 0, void 0, function* () {
        setSocialAuthRedirectUrl(service);
        if (callback) {
            // Useful for analytics goals.
            callback(service);
        }
        if (service === OauthServiceType.Telegram) {
            window.location.href = getTelegramOAuthUrl();
            return;
        }
        try {
            const { data, errors } = yield socialAuth.refetch({
                params: {
                    service,
                    backRedirectUrl: getBackRedirectUrl(service, socialAuthCallbackUrl)
                }
            });
            if (errors && errors.length) {
                onError(errors[0]);
            }
            else if (data.OauthRedirectUrl.result) {
                window.open(data.OauthRedirectUrl.message, '_top');
            }
        }
        catch (error) {
            console.error(error);
            onError === null || onError === void 0 ? void 0 : onError(error);
        }
    });
    return redirectToService;
};
